module.exports = __webpack_public_path__ + "static/media/nodejs.043bdbbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/nodejs.png
// module id = 48
// module chunks = 0